"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _Confirm = _interopRequireDefault(require("./Confirm"));

exports.default = _Confirm.default;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/addons/Confirm/index.js
// module id = 1434
// module chunks = 0